import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Image } from '../../../../common/image'
import { Table } from '../../../../common/table'
import { ThCell } from '../../../../common/table/ThCell'
import classes from '../../../index.module.scss'
import {
  selectLoadingPlanDetails,
  selectSubscriptionPlanDetailsById,
  selectSubscriptionPlanDetailsData,
  selectSubscriptionPlanDetailsIds,
} from '../../store/slice'
import { getSubscriptionPlanDetails } from '../../store/thunk'
import BenefitCheckSvg from '../icon/benefitCheck.svg'
import { DETAIL_PLANS_TITLE } from '../popupUpgrade/constants'

export const ViewDetailPlan = () => {
  const dispatch = useDispatch()

  const tableRef = useRef()

  const ids = useSelector(selectSubscriptionPlanDetailsIds)
  const dataTable = useSelector(selectSubscriptionPlanDetailsData)
  const isLoading = useSelector(selectLoadingPlanDetails)
  const locale = useSelector((state) => state.i18n.locale)

  const getSchema = () => {
    return DETAIL_PLANS_TITLE.map((item, index) => {
      const result = {
        title: <Translate value={item.title} />,
        colId: item.key,
      }
      if (index === 0) {
        return {
          ...result,
          render: (val, { rowId }) => {
            const level = dataTable[rowId]?.level || 1
            return (
              <Element
                style={{
                  marginLeft: (level - 1) * 20,
                  fontWeight: level === 1 ? 500 : 'unset',
                }}
              >
                {val}
              </Element>
            )
          },
        }
      }
      return {
        ...result,
        render: (val) => {
          if (val) {
            if (typeof val === 'string') {
              return <Element className="textCenter">{val}</Element>
            } else {
              return (
                <div className="dFlex justifyContentCenter">
                  <Image
                    src={BenefitCheckSvg}
                    className={classes.benefitCheckImg}
                  />
                </div>
              )
            }
          }
          return <></>
        },
      }
    })
  }

  useEffect(() => {
    dispatch(getSubscriptionPlanDetails())
  }, [locale])

  return (
    <div
      className="dFlex justifyContentCenter h100"
      style={{ backgroundColor: '#E5E5E5' }}
    >
      <div className={'w75 flexColumn'} style={{ backgroundColor: '#FFFFFF' }}>
        <Element
          className={[classes.viewDetailContent, 'fw500 textUppercase'].join(
            ' ',
          )}
          style={{ color: '#0553A5', fontSize: 24 }}
        >
          <Translate value="userManagement.viewDetailPlans.TITLE" />
        </Element>
        <div
          className={[classes.viewDetailContent, 'h100'].join(' ')}
          ref={tableRef}
        >
          <Table
            ids={ids}
            getDataFromRedux={selectSubscriptionPlanDetailsById}
            schema={getSchema()}
            isLoading={isLoading}
            renderTHead={() => (
              <tr style={{ justifyContent: 'center' }}>
                {DETAIL_PLANS_TITLE.map((item, index) => (
                  <ThCell
                    key={index}
                    col={{
                      ...item,
                      thStyle: { justifyContent: index === 0 ? '' : 'center' },
                    }}
                    style={{
                      backgroundColor: item.thColor,
                      border: '1px solid #E5E5E5',
                      top: -1,
                    }}
                  />
                ))}
              </tr>
            )}
          />
        </div>
      </div>
    </div>
  )
}
